"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLeverageDialog = useLeverageDialog;
var _react = require("react");
var _reactRedux = require("react-redux");
var _selectors = require("../../../../redux/margin/selectors");
var _orderEntrySelector = require("../../../../redux/selectors/orderEntrySelector");
var _actions = require("../../../../redux/margin/actions");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function useLeverageDialog(formName) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var leverageValue = (0, _reactRedux.useSelector)(_selectors.currentLeverageSelector);
  var max = (0, _reactRedux.useSelector)(_selectors.maxLeverageSelector);
  var formArgs = (0, _react.useMemo)(function () {
    return {
      formName: formName
    };
  }, [formName]);
  var isBuy = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectIsBuyForm)(state, formArgs);
  });
  var _useState = (0, _react.useState)(leverageValue !== null && leverageValue !== void 0 ? leverageValue : max),
    _useState2 = _slicedToArray(_useState, 2),
    sliderValue = _useState2[0],
    setSliderValue = _useState2[1];
  var breakpoints = (0, _react.useMemo)(function () {
    return max && max <= 10 ? Array.from({
      length: max - 1
    }, function (_, i) {
      return i + 2;
    }) : [2, max];
  }, [max]);
  (0, _react.useEffect)(function () {
    if (leverageValue !== max) {
      setSliderValue(leverageValue !== null && leverageValue !== void 0 ? leverageValue : max);
    }
  }, [max, setSliderValue, leverageValue]);

  // This needs to update slider value when open Update Leverage modal after Leverage was changed via Advanced Order form
  (0, _react.useEffect)(function () {
    setSliderValue(leverageValue && leverageValue <= max ? leverageValue : max);
  }, [leverageValue, max]);
  var onConfirm = (0, _react.useCallback)(function () {
    dispatch((0, _actions.setMarginLeverage)(sliderValue));
  }, [dispatch, sliderValue]);
  var onCancel = (0, _react.useCallback)(function () {
    setSliderValue(leverageValue !== null && leverageValue !== void 0 ? leverageValue : max);
  }, [leverageValue, max]);
  return {
    max: max,
    isBuy: isBuy,
    sliderValue: sliderValue,
    leverageValue: leverageValue,
    setSliderValue: setSliderValue,
    onConfirm: onConfirm,
    onCancel: onCancel,
    breakpoints: breakpoints
  };
}